import React, { useState } from 'react';
import BusinessUnitForm from './BusinessUnitForm';
import BusinessUnitsList from './BusinessUnitsList';
const BusinessUnitPage = _ref => {
  let {
    company,
    setCompany,
    loading,
    setLoading,
    handleToaster
  } = _ref;
  const [refreshFlag, setRefreshFlag] = useState(0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(BusinessUnitForm, {
    company: company,
    setCompany: setCompany,
    loading: loading,
    setLoading: setLoading,
    onCreated: () => setRefreshFlag(f => f + 1)
  })), /*#__PURE__*/React.createElement(BusinessUnitsList, {
    company: company,
    handleToaster: handleToaster,
    setCompany: setCompany,
    loading: loading,
    setLoading: setLoading,
    refreshFlag: refreshFlag
  }));
};
export default BusinessUnitPage;